import { createApi } from '@reduxjs/toolkit/query/react'
import { authHeaderAPI } from 'redux/_helpers/auth-header'
import { baseQueryWithErrorHandler } from 'redux/_helpers/custom-base-query'

export const HotelsAPI = createApi({
  reducerPath: 'HotelsAPI',
  baseQuery: baseQueryWithErrorHandler,
  tagTypes: ['Hotels'],
  endpoints: builder => ({
    getAllHotels: builder.query({
      query: (params: any) => ({
        url: `/api/Hotel`,
        method: 'GET',
        headers: authHeaderAPI(),
        params,
      }),
      providesTags: ['Hotels'],
    }),
    addHotel: builder.mutation({
      query: ({ body }) => ({
        url: `/api/Hotel`,
        method: 'POST',
        body,
        headers: authHeaderAPI(),
      }),
      invalidatesTags: ['Hotels'],
    }),
    updateHotel: builder.mutation({
      query: ({ body, id }) => ({
        url: `/api/Hotel/${id}`,
        method: 'PUT',
        body,
        headers: authHeaderAPI(),
      }),
      invalidatesTags: ['Hotels'],
    }),
    getHotelGeneralConfigration: builder.query({
      query: () => ({
        url: `/api/Configurations`,
        method: 'GET',
        headers: authHeaderAPI(),
      }),
      providesTags: ['Hotels'],
    }),
    getHotelById: builder.query({
      query: id => ({
        url: `/api/Hotel/${id}`,
        method: 'GET',
        headers: authHeaderAPI(),
      }),
      providesTags: ['Hotels'],
    }),

    deleteHotel: builder.mutation({
      query: id => ({
        url: `/api/Hotel/${id}`,
        method: 'DELETE',
        headers: authHeaderAPI(),
      }),
      invalidatesTags: ['Hotels'],
    }),
    deltePhoto: builder.mutation({
      query: path => ({
        url: `/api/Hotel/DeletePhoto?Path=${path}`,
        method: 'POST',
        headers: authHeaderAPI(),
      }),
      invalidatesTags: ['Hotels'],
    }),
    getPriceHotelById: builder.query({
      query: ({ id, checkout, checkin }) => ({
        url: `/api/Hotel/${id}/rooms-pricing-for-reservation?checkin=${checkin}&checkout=${checkout}`,
        method: 'GET',
        headers: authHeaderAPI(),
      }),
      providesTags: ['Hotels'],
    }),
  }),
})

export const {
  useGetAllHotelsQuery,
  useLazyGetAllHotelsQuery,
  useGetHotelGeneralConfigrationQuery,
  useGetHotelByIdQuery,
  useDeltePhotoMutation,
  useAddHotelMutation,
  useUpdateHotelMutation,
  useDeleteHotelMutation,
  useGetPriceHotelByIdQuery,
} = HotelsAPI
